module.exports = __webpack_public_path__ + "static/media/img2-2.d5eb2fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/biosense/diff/img2-2.png
// module id = 2194
// module chunks = 3